import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import { ApiErrorResponse } from '../../components/admin-dashboard-component/Regions/regions-delete/delete-regions.model';

@Injectable({
  providedIn: 'root',
})
export class RegionsDeleteService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private readonly API = environment.pharmacyMgtApiUrl;
  private readonly ENDPOINT = `${this.API}/pharmacy/regions`;

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  deleteRegion(regionId: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.ENDPOINT}/${regionId}`, { headers }).pipe(
      tap(() => console.log(`Region ${regionId} deleted successfully`)),
      catchError(this.handleError),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const apiError: ApiErrorResponse = error.error;
    return throwError(() => apiError);
  }
}
